import type { ReactNode } from "react";
import type { Contact } from "@domaddress/shared";

/** Groepsrollen op vrijwilligers-/personeelslijst (veld `group_activity` van de API). */
export default function GroupActivityBadges({ contact }: { contact: Contact }) {
  const g = contact.group_activity;
  if (!g) return null;

  if (!g.has_any_group_role) {
    return (
      <span className="group-badge group-badge--muted" title="Geen lidmaatschap of andere rol in een groep">
        Geen groepsrol
      </span>
    );
  }

  const out: ReactNode[] = [];
  if (g.is_group_chair) {
    out.push(
      <span key="chair" className="group-badge group-badge--chair" title="Voorzitter in minstens één groep">
        Voorzitter
      </span>
    );
  }
  if (g.is_group_member) {
    out.push(
      <span key="lid" className="group-badge group-badge--member" title="Lid van minstens één groep">
        Lid
      </span>
    );
  }
  if (g.is_group_admin) {
    out.push(
      <span key="adm" className="group-badge" title="Groepsbeheerder op minstens één groep">
        Beheer
      </span>
    );
  }
  if (g.is_group_viewer) {
    out.push(
      <span key="view" className="group-badge" title="Groepskijker op minstens één groep">
        Kijker
      </span>
    );
  }
  return <>{out}</>;
}
